import { render, staticRenderFns } from "./view.vue?vue&type=template&id=5f83683c&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=5f83683c&prod&lang=less&scoped=true"
import style1 from "./view.vue?vue&type=style&index=1&id=5f83683c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83683c",
  null
  
)

export default component.exports